<template>
  <div>
    <v-card outlined class="mt-4" v-for="(joined, index) in joinedItems" :key="joined.id">
      <v-card-title>
        {{ joined.name }}
        &nbsp;&nbsp;&nbsp;
        <v-btn v-if="joined.joined_id" @click="editItem = { id: joined.joined_id, item: joined, show: true }" color="primary" fab text small dark>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn v-if="joined.joined_id" @click="copyToClipboard(joined.joined_id)" color="primary" fab text small dark>
          <v-icon>mdi-code-tags</v-icon>
        </v-btn>
        <v-btn v-if="joined.joined_id" @click="joinedChangeId = joined.joined_id" color="primary" fab text small dark>
          <v-icon>mdi-account-convert-outline</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="row">
          <div v-if="joined.fundraising && joined.fundraising.unit_price !== joined.amount_to_pay" class="col-12">
            <v-alert type="error" class="mb-0">A meta dessa arrcadação é {{ joined.fundraising.unit_price | price }}. Por favor verificar se está correto!</v-alert>
          </div>
          <div v-if="joined.max_installments >= 0 && joined.number_of_installment !== joined.max_installments" class="col-12">
            <v-alert type="error" class="mb-0">A quantidade de parcelas dessa arrecadação é {{ joined.max_installments }}. Por favor verificar se está correto!</v-alert>
          </div>
          <div v-if="joined.has_previous_provisioning" class="col-12">
            <v-alert type="error" class="mb-0">Existem provisionamentos em aberto com datas anteriores. Por favor verificar!</v-alert>
          </div>
          <div v-if="joined.max_installments >= 0 && joined.has_more_provisioning" class="col-12">
            <v-alert type="error" class="mb-0">Existem provisionamentos além da quantidade de parcelas. Por favor verificar!</v-alert>
          </div>
          <div class="col-12 col-sm-4">
            <v-alert dense color="blue-grey lighten-5" class="mb-0">
              <div class="row">
                <div class="col-6 col-sm-12 col-md-6">
                  <span class="caption">Meta</span>
                  <br>
                  {{ joined.amount_to_pay | price }}
                </div>
                <div class="col-6 col-sm-12 col-md-6">
                  <span class="caption">Parcelas restantes</span>
                  <br>
                  {{ joined.number_of_installment }}x <small>({{ joined.method | payment_method }}<template v-if="joined.period && joined.period !== 'ALL'"> | {{ joined.period }}</template>)</small>
                </div>
              </div>
            </v-alert>
          </div>
          <div class="col-12 col-sm-8">
            <v-alert dense color="green lighten-5" class="mb-0">
              <div class="row">
                <div class="col-6 col-md-3">
                  <span class="caption">Total Pago</span>
                  <br>
                  <b>{{ joined.total_paid | price }}</b>
                </div>
                <div class="col-6 col-md-3">
                  <span class="caption">Pago por fora</span>
                  <br>
                  {{ joined.total_paid_before | price }}
                </div>
                <div class="col-6 col-md-3">
                  <span class="caption">Pago pela Heppi</span>
                  <br>
                  {{ joined.total_paid_without_interest_and_fine | price }}
                </div>
                <div class="col-6 col-md-3">
                  <span class="caption">Juros pago</span>
                  <br>
                  {{ joined.total_paid_interest_and_fine | price }}
                </div>
              </div>
            </v-alert>
          </div>
          <div class="col-6 col-md-2">
            <v-alert dense color="red lighten-5" class="mb-0">
              <div class="row">
                <div class="col-12">
                  <span class="caption">Total atrasado</span>
                  <br>
                  {{ joined.total_late | price }}
                </div>
              </div>
            </v-alert>
          </div>
          <div class="col-6 col-md-2">
            <v-alert dense color="blue lighten-5" class="mb-0">
              <div class="row">
                <div class="col-12">
                  <span class="caption">Em aberto</span>
                  <br>
                  {{ joined.total_pending | price }}
                </div>
              </div>
            </v-alert>
          </div>
          <div class="col-12 col-sm-8">
            <v-alert dense color="blue-grey lighten-5" class="mb-0">
              <div class="row">
                <div class="col-6 col-md-3">
                  <span class="caption">Prov. Renegociação</span>
                  <br>
                  <template v-if="joined.loading_provisioning_itens">Carregando</template>
                  <template v-else>{{ joined.provisioning_renegotiation | price }}</template>
                </div>
                <div class="col-6 col-md-3">
                  <span class="caption">Prov. Adicional</span>
                  <br>
                  <template v-if="joined.loading_provisioning_itens">Carregando</template>
                  <template v-else>{{ joined.provisioning_additional | price }}</template>
                </div>
                <div class="col-6 col-md-3">
                  <span class="caption">Prov. Desconto</span>
                  <br>
                  <template v-if="joined.loading_provisioning_itens">Carregando</template>
                  <template v-else>{{ joined.provisioning_discount | price }}</template>
                </div>
                <div class="col-6 col-md-3">
                  <span class="caption">Prov. Juros</span>
                  <br>
                  <template v-if="joined.loading_provisioning_itens">Carregando</template>
                  <template v-else>{{ joined.provisioning_interest_and_fines | price }}</template>
                </div>
              </div>
            </v-alert>
          </div>
        </div>
      </v-card-text>
      <div class="row align-center" v-if="joined.number_of_installment && joined.number_of_installment > 0 && !joined.loading_provisioning_itens">
        <div class="col">
          <v-divider />
        </div>
        <div class="col-auto">
          <v-btn dense color="default" text @click="openJoined(index, !joined.opened)">{{ joined.opened ? 'Ocultar' : 'Mostrar' }} próximas parcelas</v-btn>
        </div>
        <div class="col">
          <v-divider />
        </div>
      </div>
      <v-card-text v-if="joined.opened && joined.number_of_installment && joined.number_of_installment > 0">
        <div class="row">
          <div v-for="i in joined.number_of_installment" :key="i" class="col-4 col-sm-3 col-md-2">
            <span class="caption">{{ getNextMonth(i) }}</span>
            <br>
            <span class="error--text" v-if="monthlyValue(index, i) <= 0">{{ monthlyValue(index, i) | price }}</span>
            <template v-else>{{ monthlyValue(index, i) | price }}</template>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <!-- <v-data-table
      :headers="joinedHeaders"
      :items="joinedItems"
      :loading="loading"
      :disable-pagination="true"
      no-data-text="Nenhuma arrecadação"
      no-results-text="Nenhuma arrecadação"
      :hide-default-footer="true"
    >
      <template v-slot:item.actions="{ item }">
        <div class="no-wrap">
          <v-btn v-if="item.joined_id" @click="editItem = { id: item.joined_id, item: item, show: true }" color="primary" fab text small dark>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn v-if="item.joined_id" @click="copyToClipboard(item.joined_id)" color="primary" fab text small dark>
            <v-icon>mdi-code-tags</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.name="{ item }">
        {{ item.name }} <template v-if="item.nickname"><br>({{ item.nickname }})</template>
      </template>
      <template v-slot:item.amount_to_pay="{ item }">
        <span style="white-space: nowrap">{{ item.amount_to_pay | price }}</span>
      </template>
      <template v-slot:item.total_paid="{ item }">
        <span style="white-space: nowrap">{{ item.total_paid | price }}</span>
      </template>
      <template v-slot:item.total_paid_before="{ item }">
        <span style="white-space: nowrap">{{ item.total_paid_before | price }}</span>
      </template>
      <template v-slot:item.total_paid_without_interest_and_fine="{ item }">
        <span style="white-space: nowrap">{{ item.total_paid_without_interest_and_fine | price }}</span>
      </template>
      <template v-slot:item.total_paid_interest_and_fine="{ item }">
        <span style="white-space: nowrap">{{ item.total_paid_interest_and_fine | price }}</span>
      </template>
      <template v-slot:item.total_late="{ item }">
        <span style="white-space: nowrap">{{ item.total_late | price }}</span>
      </template>
      <template v-slot:item.total_pending="{ item }">
        <span style="white-space: nowrap">{{ item.total_pending | price }}</span>
      </template>
      <template v-slot:item.total_financial_negotiations="{ item }">
        <span style="white-space: nowrap">{{ item.total_financial_negotiations | price }}</span>
      </template>
      <template v-slot:item.payment_method="{ item }">
        <template v-if="item.installment_method.method === null"></template>
        <template v-else-if="item.number_of_installment">
          {{ item.number_of_installment }}x ({{ item.method | payment_method }})
        </template>
        <template v-else>
          Sem parcelas
        </template>
      </template>
    </v-data-table> -->
    <v-toolbar class="elevation-0">
      <v-toolbar-title class="pl-0">Outras arrecadações da turma</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table
        :headers="fundraisingHeaders"
        :items="fundraisingItems"
        :loading="loading"
        :disable-pagination="true"
        no-data-text="Nenhuma arrecadação"
        no-results-text="Nenhuma arrecadação"
        :hide-default-footer="true"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn :to="{ name: 'newJoined', params: { fundraisingId: item.id, celebrationId }, query: { participant: participantId } }" color="primary" fab text small dark>
            <v-icon>mdi-account-plus</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.description="{ item }">
          {{ (item.description && item.description.length > 33) ? item.description.substr(0,30) + '...' : item.description }}
        </template>
        <template v-slot:item.unit_price="{ item }">
          {{ item.unit_price | price }}
        </template>
        <template v-slot:item.start_date="{ item }">
          {{ item.start_date | moment('MM/YYYY') }}
        </template>
        <template v-slot:item.finish_date="{ item }">
          {{ item.finish_date | moment('MM/YYYY') }}
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | moment('DD/MM/YYYY hh:mm:ss') }}
        </template>
      </v-data-table>
    <edit-modal
      :id="editItem.id"
      :item="editItem.item"
      v-if="editItem.show"
      @canceled="editItem.show = false"
      @error="editItem.show = false"
      @edited="editItem.show = false; $emit('edited')"
    ></edit-modal>
    <joined-change-modal
      :id="joinedChangeId"
      v-if="joinedChangeId"
      :joineds="joinedItems"
      @canceled="joinedChangeId = null"
      @error="joinedChangeId = null"
      @edited="joinedChangeId = null; $emit('edited')"
    ></joined-change-modal>
  </div>
</template>

<script>
import axios from 'axios'
import EditModal from '@/components/EditModals/Joined'
import JoinedChangeModal from '@/components/EditModals/JoinedChange'
import { mapActions } from 'vuex'

export default {
  name: 'participants',
  components: {
    EditModal,
    JoinedChangeModal
  },
  props: {
    type: {
      type: String,
      default: 'fundraisings'
    },
    participantId: {
      type: String
    },
    celebrationId: {
      type: String
    },
    parcialInfo: {
      type: [String, Array],
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      quicksearch: '',
      joinedItems: [],
      joinedHeaders: [
        {
          text: '',
          value: 'actions',
          sortable: false
        },
        {
          text: 'Nome',
          value: 'name'
        },
        {
          text: 'Total',
          value: 'amount_to_pay'
        },
        {
          text: 'Total Pago',
          value: 'total_paid'
        },
        {
          text: 'Pago por fora',
          value: 'total_paid_before'
        },
        {
          text: 'Pago Heppi',
          value: 'total_paid_without_interest_and_fine'
        },
        {
          text: 'Juros pago',
          value: 'total_paid_interest_and_fine'
        },
        {
          text: 'Atrasado',
          value: 'total_late'
        },
        {
          text: 'Em aberto',
          value: 'total_pending'
        },
        {
          text: 'Provisionado (Renegociações)',
          value: 'total_financial_negotiations'
        },
        {
          text: 'Forma de pagamento',
          value: 'payment_method'
        }
      ],
      fundraisingItems: [],
      fundraisingHeaders: [
        {
          text: '',
          sortable: false,
          value: 'actions'
        },
        {
          text: 'Nome',
          value: 'name'
        },
        {
          text: 'Descrição',
          sortable: false,
          value: 'description'
        },
        {
          text: 'Valor total',
          sortable: false,
          align: 'right',
          value: 'unit_price'
        },
        {
          text: 'Inicia em',
          value: 'start_date'
        },
        {
          text: 'Termina em',
          value: 'finish_date'
        },
        {
          text: 'Criado em',
          value: 'created_at'
        }
      ],
      editItem: {
        item: {},
        id: null,
        show: false
      },
      joinedChangeId: null
    }
  },
  watch: {
    parcialInfo () {
      if (this.celebrationId) this.getData()
    }
  },
  methods: {
    ...mapActions(['copyToClipboard']),
    getData () {
      let vue = this
      vue.loading = true

      axios.get('fundraisings?filter[celebration_id]=' + this.celebrationId)
        .then(response => {
          if (response.data && response.data.data) {
            for (const index in response.data.data) {
              const fundraising = response.data.data[index]
              const joinedIndex = this.parcialInfo.findIndex(e => e.id === fundraising.id)
              if (joinedIndex >= 0) {
                const newJoined = { ...this.joinedItems[joinedIndex] }
                newJoined.fundraising = fundraising
                newJoined.opened = false
                newJoined.max_installments = this.maxInstallment(fundraising.finish_date)
                this.$set(this.joinedItems, joinedIndex, newJoined)
                if (newJoined.provisioning_renegotiation >= 0) this.setProvisioningTotals(index)
              } else {
                this.fundraisingItems.push(fundraising)
              }
            }
          } else {
            vue.fundraisingItems = []
          }
          vue.loading = false
        })
        .catch(() => {
          vue.loading = false
          vue.fundraisingItems = []
        })
    },
    getNegotiationData (index, page) {
      const newJoined = { ...this.joinedItems[index] }

      axios.get(`/financial-negotiations?page[size]=30&page[number]=${page}&filter[joined_id]=${newJoined.joined_id}`)
        .then(response => {
          if (response.data) {
            const data = response.data.data
            const meta = response.data.meta

            if (data) {
              newJoined.negotiations = [...newJoined.negotiations, ...data]
              this.$set(this.joinedItems, index, newJoined)
            }

            if (meta && meta.current_page < meta.last_page) {
              this.getNegotiationData(index, page + 1)
            } else {
              newJoined.loading_provisioning_itens = false
              this.$set(this.joinedItems, index, newJoined)
              this.setProvisioningTotals(index)
            }
          }
        })
        .catch(() => {
          newJoined.loading_provisioning_itens = false
          this.$set(this.joinedItems, index, newJoined)
        })
    },
    setProvisioningTotals (index) {
      const newJoined = { ...this.joinedItems[index] }
      newJoined.provisioning_renegotiation = 0
      newJoined.provisioning_additional = 0
      newJoined.provisioning_discount = 0
      newJoined.provisioning_interest_and_fines = 0
      newJoined.has_previous_provisioning = false
      newJoined.has_more_provisioning = false

      for (const i in newJoined.negotiations) {
        const item = newJoined.negotiations[i]

        if (!item.generated_invoice && item.category === 'renegotiation') {
          newJoined.provisioning_renegotiation += item.installment_amount
        }

        if (!item.generated_invoice && item.category === 'additional') {
          newJoined.provisioning_additional += item.installment_amount
        }

        if (!item.generated_invoice && item.category === 'discount') {
          newJoined.provisioning_discount += item.installment_amount
        }

        if (!item.generated_invoice && item.category === 'interest_and_fines') {
          newJoined.provisioning_interest_and_fines += item.installment_amount
        }

        const itemDate = this.$moment(item.due_date).startOf('month')
        const actualData = this.actualMoment().startOf('month')
        const monthDiff = itemDate.diff(actualData, 'months')

        if (!item.generated_invoice && monthDiff <= 0) {
          newJoined.has_previous_provisioning = true
        }

        if (!item.generated_invoice && monthDiff > newJoined.max_installments) {
          newJoined.has_more_provisioning = true
        }
      }

      this.$set(this.joinedItems, index, newJoined)
    },
    openJoined (index, value) {
      const newJoined = { ...this.joinedItems[index] }
      newJoined.opened = value
      this.$set(this.joinedItems, index, newJoined)
    },
    actualMoment () {
      let actualMoment = this.$moment()
      const actualDay = parseInt(actualMoment.format('D'))
      if (actualDay < 5) actualMoment.subtract(1, 'months')
      return actualMoment
    },
    maxInstallment (finishDate) {
      const actualMonth = this.$moment(this.actualMoment()).startOf('month')
      const finishMonth = this.$moment(finishDate, 'YYYY-MM-DD').startOf('month')
      const monthDiff = finishMonth.diff(actualMonth, 'months')
      return monthDiff > 0 ? monthDiff : 0
    },
    getNextMonth (i) {
      const momentMonth = this.$moment(this.actualMoment())
      momentMonth.add(i, 'months')
      return momentMonth.format('MMMM YYYY')
    },
    monthlyValue (index, i) {
      const momentMonth = this.$moment(this.actualMoment())
      momentMonth.add(i, 'months')

      const joined = { ...this.joinedItems[index] }
      const monthlyNegotiations = joined.negotiations.filter(e => !e.generated_invoice && this.$moment(e.due_date).format('YYYYMM') === momentMonth.format('YYYYMM'))
      let futureValue = joined.amount_to_pay
      if (joined.total_paid) futureValue -= joined.total_paid
      if (joined.total_late) futureValue -= joined.total_late
      if (joined.total_pending) futureValue -= joined.total_pending
      if (joined.provisioning_renegotiation) futureValue -= joined.provisioning_renegotiation
      if (joined.provisioning_additional) futureValue -= joined.provisioning_additional
      if (joined.provisioning_discount) futureValue += joined.provisioning_discount

      let monthProvisioning = 0
      if (monthlyNegotiations.length > 0) {
        for (const i in monthlyNegotiations) {
          const item = monthlyNegotiations[i]
          if (item.category === 'renegotiation') monthProvisioning += item.installment_amount
          if (item.category === 'additional') monthProvisioning += item.installment_amount
          if (item.category === 'discount') monthProvisioning -= item.installment_amount
          if (item.category === 'interest_and_fines') monthProvisioning += item.installment_amount
        }
      }

      const installments = joined.number_of_installment || 0

      return (installments) ? futureValue / installments + monthProvisioning : 0
    }
  },
  mounted () {
    if (this.parcialInfo && this.parcialInfo.length > 0) this.joinedItems = [...this.parcialInfo]
    else this.joinedItems = []

    if (this.celebrationId) this.getData()
    else this.fundraisingItems = []

    if (this.joinedItems.length > 0) {
      for (const i in this.joinedItems) {
        const newJoined = { ...this.joinedItems[i] }
        newJoined.loading_provisioning_itens = true
        newJoined.negotiations = []
        this.$set(this.joinedItems, i, newJoined)
        setTimeout(() => {
          this.getNegotiationData(i, 1)
        }, 1000)
      }
    }
  }
}
</script>
